<ng-container *ngIf="currentUser$ | async as user">
  <nav [ngClass]="stateService.moduleType == moduleType.Marketer ? 'navbar-marketer': 'navbar-affiliate'"
    class="navbar navbar-light bg-faded justify-content-center">
    <div class="container container-fluid d-flex flex-row">
      <div class="container container-1400">
        <a href="/" class="navbar-brand d-flex">
          <img class="logo" src="assets/icons/logo-black.png" />
        </a>

        <ng-container *ngIf="!isPayingUser && IsTrialAlreadyUsed">
          <div class="mx-auto d-none d-lg-block">
            To unlock full capabilities, click the button and upgrade to VidTao
            Premium!
          </div>
          <a (click)="OpenPayingPlanPicker()" class="upgrade-button">Upgrade</a>
        </ng-container>

        <ng-container *ngIf="!isPayingUser && !IsTrialAlreadyUsed">
          <div class="mx-auto d-none d-lg-block">
            Start you <span class="bold">free trial</span> and unlock full capabilities for <span class="bold">7
              days!</span>
          </div>
          <a (click)="StartTrial()" class="upgrade-button">Start trial</a>
        </ng-container>
      </div>
    </div>
  </nav>
</ng-container>